import styled from "styled-components";
import colors from "../../../../../../constants/style-constants/colors";

export const Input = styled.input``;

export const InputBorder = styled.div`
  -webkit-box-shadow: 0 0 7px #c1c1c1;
  box-shadow: 0 0 7px #c1c1c1;
`;

export const Type = styled.div`
  -webkit-box-shadow: 0 0 7px #c1c1c1;
  box-shadow: 0 0 7px #c1c1c1;
  height: 2rem;
  border-radius: 0.7rem;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding-top: 1rem;
  flex-basis: 50%;
  max-width: 48%;
  cursor: pointer;
  border: ${(props) => (props.isSelected ? props.isSelected : "none")};

  :hover {
    color: #2a3da3;
    border: 1px solid #2a3da3;
  }
`;
export const EditImageDiv = styled.div`
  display: flex;
  -webkit-box-shadow: 0 0 7px #c1c1c1;
  box-shadow: 0 0 7px #c1c1c1;
  height: fit-content;
  margin: 5px;
  justify-content: space-between;
  align-items: center;
`;
export const Btn = styled.button`
  border: none;
  width: 10rem;
  border-radius: 0.6rem;
  color: white;
  background-color: #2a3da3;
`;
